// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qa_a bhb_rq bhb_kr bhb_ks","PostDetailRight__brandDaysPosts":"qa_b bhb_rq bhb_kr bhb_ks"};